import type { AccordionData } from "@/design-system/Molecules/AccordionList/Accordion.types";
import React from "react";

const faqPairs: [string, React.ReactNode][] = [
  [
    "Why Choose Defy Medical?",
    <>
      Defy Medical is an expert Men’s Health clinic. We take sexual health
      seriously, and we’ve put together a simple process to access treatment
      through DefyED. Our providers are experienced in treating ED along with
      low Testosterone, hair loss, weight gain, muscle loss, and more. In
      addition to our ED treatment, we offer a suite of health care services.{" "}
      <a
        href="https://www.defymedical.com/"
        target="_blank"
        rel="noopener noreferrer"
        className="text-[#181a20] underline"
      >
        Learn more about us.
      </a>
    </>,
  ],
  [
    "How does ED treatment work at Defy Medical?",
    <>
      It’s simple! fill out our online questionnaire to provide us with details
      about your health history. Then we’ll give you recommendations on the best
      medications for you. Order your medication online and have it delivered
      directly to your door.
    </>,
  ],
  [
    "What is the shipping process for my medication?",
    <>
      Once you place an order, Defy Medical sends it to a pharmacy within our
      Pharmacy Network. The pharmacy then ships your medication directly to your
      door. You’ll receive a tracking number when your order ships.
    </>,
  ],
  [
    "What are ED injections?",
    <>
      ED injections are penile injections that deliver potent ingredients
      directly to the penis for greater effect. Male patients report powerful
      erections that start within 15 minutes and last up to an hour. ED
      injections often provide results when oral medications like Sildenafil
      fail. If you've tried other medications that didn’t work, or you’d prefer
      a faster and more reliable ED solution, ED injections may be right for
      you.
    </>,
  ],
  [
    "Can I combine ED medications?",
    <>
      We do not recommend combining ED medications, especially ED injections and
      traditional oral medications. This can lead to a potential medical
      emergency called priapism, or an erection lasting longer than 4 hours.
      Instead of combining therapies, work with Defy Medical to find the right
      medication and dosage for the results you want.
    </>,
  ],
  [
    "How long does it take to see results from ED medications?",
    <>
      Result times depend on the medication and the patient’s response. In
      general, oral medications typically take around 30 minutes to an hour,
      while ED injections trigger a response in 5-15 minutes on average.
    </>,
  ],
];
export const oralMedFaqData: AccordionData[] = faqPairs.map(
  ([question, answer]) => ({
    question,
    answer,
  })
);
